<p><a routerLink="/project">My Projects </a><span *ngIf="projectName !== null"> > </span> {{projectName !== null ? projectName.ProjectName : ''}} </p>